import { useNavigate } from "react-router-dom";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { GoEye } from "react-icons/go";
import { useState } from "react";
import nodeinstance from "../../../../nodeInstance";
import { useEffect } from "react";
import Vendor_PopUp from "./vendor_popUp";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import ExcelUpload from "./uploadExcel";

export default function Vendor_payment({ titles }) {
  const [dependentDetails, setDependentdetails] = useState();
  const token = localStorage.getItem("nodeToken");
  const [trigger, setTrigger] = useState(false);

  const response = async () => {
    try {
      const response = await nodeinstance.get(
        "/insurance-dependent/insuranceVendorPayment",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setDependentdetails(response.data);
      }
    } catch (error) {
      console.log("error to be seen here...", error);
    }
  };
  useEffect(() => {
    response();
  }, [trigger]);
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(dependentDetails?.data || []);
  const [searchWords, setSearchWords] = useState([]);
  const navigate = useNavigate();

  const [popUp, setPopUp] = useState(false);
  const [propData, setPropData] = useState();

  const handlePopUp = (value) => {
    setPopUp(true);
    setPropData(value);
  };

  const [downloadLoading, setDownloadLoading] = useState(false);
  const dispatch = useDispatch();
  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `/insurance-dependent/excelTemplate`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Dependent_template`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };
  const [excelPopUp, setExcelPopUp] = useState(false);
  const handleExcelOpen = () => {
    setExcelPopUp(true);
    // setPropData(value);
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const monthName = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day}-${monthName.toLowerCase()}-${year}`;
  };
  const [fileter, setFilter] = useState("");
  console.log("filter date should be poppulated here....", fileter);
  const formattedInputDate = fileter ? formatDate(fileter) : "";

  // Filter the list based on the iqama expiry date if input date is provided
  const filteredList = !fileter
    ? dependentDetails?.data
    : dependentDetails?.data.filter((list) => {
        const formattedIqamaExpiryDate = formatDate(list.iqama_expiry_date_g);
        return formattedIqamaExpiryDate === formattedInputDate;
      });
      const [downloadLoadingReport, setDownloadLoadingReport] = useState(false);
      // const dispatch = useDispatch();
      const downloadFileReport = async () => {
        setDownloadLoadingReport(true);
        try {
          const response = await nodeinstance.get(
            `/insurance-dependent/InsuranceVendorReport`,
            {
              responseType: "blob",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.status === 200) {
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Insurance_OPS2_upload_template`);
            document.body.appendChild(link);
            link.click();
            dispatch(
              setAppError({
                msg: "Excel Downloaded",
                color: "success",
              })
            );
            setDownloadLoading(false);
          } else {
            throw new Error("Something went wrong!");
          }
        } catch (err) {
          setDownloadLoading(false);
          dispatch(
            setAppError({
              msg: err.message,
            })
          );
        }
      };
  return (
    <>
      <div className="flex justify-between items-center gap-x-4 mt-4">
        {/* Left side content */}
        <div className="flex gap-x-4">
          <Search
            searchKey={[
              "employee_id",
              "passport_number",
              "iqama_number",
              "client_id",
              "emp_id",
              "sponsor_id",
            ]}
            setSearchWords={setSearchWords}
          />
          <button
            className="bg-black text-white px-4 rounded-md py-2 text-sm h-[36px]"
            onClick={() => downloadFileReport()}
          >
            DOWNLOAD
          </button>
          <input
            type="date"
            className="px-4 rounded-md"
            onChange={(e) => {
              setFilter(e.target.value);
            }}
          />
        </div>

        {/* Right side buttons */}
        <div className="flex gap-x-4">
          <button
            className="bg-black text-white px-4 rounded-md py-2 text-sm h-[36px]"
            onClick={() => {
              downloadFile();
            }}
          >
            Download TEMPLATE
          </button>
          <button
            className="bg-black text-white px-4 rounded-md py-2 text-sm h-[36px]"
            onClick={() => {
              handleExcelOpen();
            }}
          >
            Update Details
          </button>
        </div>
      </div>

      <div
        className="overflow-x-auto mt-10"
        style={{ backgroundColor: "white" }}
      >
        <table className="min-w-full divide-gray-200">
          <thead className="bg-gray-100">
            <tr>
              {titles.map((columnName, index) => (
                <th
                  key={index}
                  scope="col"
                  className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider font-semibold"
                >
                  {columnName}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-gray-10">
            {filteredList?.map((listItem, index) => (
              <tr key={index}>
                <td className="px-6 py-4 whitespace-nowrap">{index + 1}</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.dependent_name}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {/* {listItem?.dependent_dob ? listItem?.dependent_dob : "------"} */}
                  {listItem.dependent_dob
                    ? new Date(listItem.dependent_dob)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .split(" ")
                        .join("-")
                        .toUpperCase()
                    : "-----"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.dependent_iqama_number}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.dependent_relation}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.insurance_class}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.dependent_gender}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.HEAD_OF_FAMILY}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {/* {listItem?.Insurance_updatedDate} */}
                  {listItem.Insurance_updatedDate
                    ? new Date(listItem.Insurance_updatedDate)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .split(" ")
                        .join("-")
                        .toUpperCase()
                    : "-----"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.amount ? listItem.amount : "-----"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {String(listItem.invoice_no ? listItem.invoice_no : "------")}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <button
                    onClick={() => {
                      handlePopUp(listItem);
                    }}
                  >
                    <GoEye fontSize={22} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Pagination />
      {popUp ? (
        <Vendor_PopUp
          popUp={popUp}
          setPopUp={setPopUp}
          propData={propData}
          setTrigger={setTrigger}
          trigger={trigger}
        />
      ) : (
        ""
      )}
      {excelPopUp ? (
        <ExcelUpload
          excelPopUp={excelPopUp}
          setExcelPopUp={setExcelPopUp}
          setTrigger={setTrigger}
          trigger={trigger}
        />
      ) : (
        ""
      )}
    </>
  );
}
